<script>
  import { useUrlParams } from "@stores/urlStore.js";
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";
  import FilterModal from "./FilterModal.svelte";
  import { Button } from "paxray-components-svelte";

  import { pmfilters } from "lib/stores.js";
  import { fly } from "svelte/transition";
  import { Modal } from "carbon-components-svelte";
  import { FILTER_ALT_ICON, MINUS_ICON, PLUS_ICON, RESET_ICON } from "@utils/icons.js";

  const urlParams = useUrlParams();
  const { getFilterByCurrentView } = filtersConfigStore;

  export let allFiltersDisabled = false;

  let modalOpen = false;
  let modalHistoryOpen = false;
  let filterid = -1;
  let filterHistory = getFilterHistory();
  let filterOpen = false;
  let disabledFilters = 0;

  $: ({ analysisid } = $urlParams);
  $: if (analysisid && !$pmfilters[analysisid]) $pmfilters[analysisid] = [];
  $: ({
    views,
    filterDefinitions,
    filterColumnDefinitions,
    filterAllowedOperators,
    filterOperators,
    currentView,
    tab,
    storeLoaded,
  } = $filtersConfigStore);

  let filtersByView = {};
  $: {
    if (storeLoaded) {
      filtersByView = getFilterByCurrentView(
        views,
        filterDefinitions,
        filterColumnDefinitions,
        filterAllowedOperators,
        filterOperators,
        currentView,
        tab,
      );
    }
  }

  $: filters = filtersByView;

  $: filterLength = ($pmfilters[analysisid] || []).length;

  $: {
    $pmfilters[analysisid];
    filterHistory = getFilterHistory();
  }

  $: if (
    (analysisid && $pmfilters[analysisid] && storeLoaded && currentView) ||
    (storeLoaded && tab)
  ) {
    disabledFilters = getDisabledFilters(currentView);
  }

  function isApplicable(filter) {
    if (!filter) return false;
    if (allFiltersDisabled) return false;
    if (
      currentView === "Workloads" &&
      tab === "Users" &&
      filter.col === "team"
    ) {
      return false;
    }
    const filtersView = filtersByView;
    const filterTab = filtersView.filter((filterView) => {
      return (
        filterView.type === filter.type && filterView.title === filter.title
      );
    });
    if (filterTab.length === 0) return false;
    const result = filterTab.some((filterView) => {
      if (filterView.filterDetails.length === 0) return true;

      return filterView.filterDetails.some((filterDetail) => {
        const colMatch =
          filterDetail.column === filter.col ||
          filterDetail.columns === filter.col ||
          (Array.isArray(filterDetail.columns) &&
            Array.isArray(filter.col) &&
            arraysEqual(filter.col, filterDetail.columns));

        const datatypeMatch =
          !filterDetail.datatype ||
          (Array.isArray(filterDetail.datatype)
            ? filterDetail.datatype.includes(filter.datatype)
            : filterDetail.datatype === filter.datatype);

        return colMatch && datatypeMatch;
      });
    });
    return result;
  }

  function arraysEqual(a, b) {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((value, index) => value === sortedB[index]);
  }

  function getDisabledFilters(currentView) {
    if (!currentView && !storeLoaded) {
      return [];
    }

    return $pmfilters[analysisid].filter((filter) => !isApplicable(filter))
      .length;
  }

  function toggleFilterbar() {
    filterOpen = !filterOpen;
  }

  function getFilterHistory() {
    const filterHistory = localStorage.getItem("filterHistory");
    if (filterHistory) {
      return JSON.parse(filterHistory);
    }
    return [];
  }

  function setHistoryFilter(filter) {
    const historyFilter = localStorage.getItem("filterHistory");
    if (historyFilter) {
      const filterHistory = JSON.parse(historyFilter);
      filterHistory.unshift(filter);
      if (filterHistory.length > 5) {
        filterHistory.pop();
      }
      localStorage.setItem("filterHistory", JSON.stringify(filterHistory));
    } else {
      localStorage.setItem("filterHistory", JSON.stringify([filter]));
    }
    filterid = -1;
  }

  function saveFilter(filterCreate) {
    const filterid = $pmfilters[analysisid].length;
    $pmfilters[analysisid][filterid] = filterCreate;
    modalOpen = false;
    setHistoryFilter(filterCreate);
    filterHistory = getFilterHistory();
  }
</script>

<Button
  kind="secondary"
  icon={FILTER_ALT_ICON}
  on:click={toggleFilterbar}
  notificationNumber={filterLength}
  disabled={disabledFilters}
/>

{#if filterOpen}
  <div transition:fly={{ x: 20 }} class="filter_wrapper">
    <div class="filter_actions">
      <Button
        icon={PLUS_ICON}
        iconLeft={true}
        kind="secondary"
        text="Add Filter"
        on:click={() => {
          filterid = $pmfilters[analysisid].length;
          modalOpen = true;
        }}
      />
      <!-- @Adrian dieser Button hatte in der Repo, die ich gefunden habe, keine Funktion (bzw. ist die gleiche, wie "Add Filter") -->
      <Button
        icon={RESET_ICON}
        kind="secondary"
        iconLeft={true}
        text="Reset Filters"
        on:click={() => {
          $pmfilters[analysisid] = [];
          $pmfilters = $pmfilters;
        }}
      />
    </div>
    <div class="filter_container">
      {#key `${currentView}-${tab}`}
        {#each $pmfilters[analysisid] as filter, id}
          <div class={`filter ${!isApplicable(filter) ? "disable" : ""}`}>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              on:click={() => {
                if (!isApplicable(filter)) return;
                filterid = id;
                modalOpen = true;
              }}>{filter.name}</span
            >
            <Button
              kind="secondary"
              icon={MINUS_ICON}
              on:click={() => {
                $pmfilters[analysisid].splice(id, 1);
                $pmfilters = $pmfilters;
              }}
            />
          </div>
        {/each}
      {/key}
    </div>
    <div class="filter_actions">
      <Button
        kind="secondary"
        text="Filter History"
        on:click={() => (modalHistoryOpen = !modalHistoryOpen)}
      />
    </div>
  </div>
{/if}

<FilterModal
  bind:modalOpen
  bind:filterid
  {analysisid}
  {filterLength}
  {setHistoryFilter}
/>

<Modal
  class="history-modal"
  modalHeading="Filter History"
  preventCloseOnClickOutside
  size="lg"
  open={modalHistoryOpen}
  passiveModal
  on:close={() => (modalHistoryOpen = false)}
>
  <div class="button_history_wrapper">
    {#each filterHistory as filter}
      <Button
        kind="secondary"
        text={filter.name || "Unnamed Flow Filter"}
        on:click={() => saveFilter(filter)}
      />
    {/each}
  </div>
</Modal>

<style>
  .filter_wrapper {
    position: fixed;
    right: 0;
    top: var(--app-header-height);
    bottom: 0;
    z-index: 20;
    width: min(22rem, calc(100vw - var(--app-side-nav-width)));
    min-width: 0;
    background-color: var(--pax-white);
    color: var(--pax-black);
    padding: 1rem;
    box-sizing: border-box;
    border-left: 1px solid #d9d9d9;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .filter_wrapper::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: -0.3rem;
    width: 0.3rem;
    background: linear-gradient(to left, #d9d9d9, transparent);
  }

  .filter_container {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.5rem;
    min-height: 0;
    overflow-y: auto;
  }

  .filter_actions {
    display: flex;
    gap: 0.5rem;
  }

  .filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
  }

  span {
    display: block;
    flex-grow: 1;
    max-width: calc(100% - 3.5rem);
    height: 3rem;
    background-color: var(--pax-smoke);
    border-radius: 0.5rem;
    align-items: center;
    padding: 0 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 3rem;
  }

  .filter.disable {
    pointer-events: auto;
    cursor: not-allowed !important;
  }

  .filter.disable span {
    pointer-events: auto;
    color: var(--pax-black-inactive);
    cursor: not-allowed;
  }

  .button_history_wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin: 1rem 0;
    box-sizing: border-box;
    justify-content: center;
  }
</style>
